import { IProductCard, ProductCardType } from '@/helpers/constants/productCards';
import { useAccountStore } from '@/stores/account';
import { productCards } from '@/helpers/constants/productCards';

interface ParamsBannerProducts {
  include?: ProductCardType[]
}

export const useProductCards = (params?: ParamsBannerProducts) => {
  const storeAccount = useAccountStore();

  const getBannerProducts = ({ include }: ParamsBannerProducts) => {
    const productsToShow: IProductCard[] = []

    productCards
      .filter((product) => include?.includes(product.type))
      .forEach((product) => {
        const allCountries = !product?.onlyCountries?.length
        const onlyCountry = product.onlyCountries.includes(storeAccount.getCompanyCountry)
        if (allCountries || onlyCountry) {
          productsToShow.push(product)
        };
      });

    return productsToShow
  }

  return {
    showProducts: getBannerProducts({ include: params?.include || [] }),
    getBannerProducts
  }
}
